<template>
  <div v-show="addGoodsPop.isShow" class="add-goods-pop">
    <Popup ref="popup" title="添加商品链接" @close="onClose">
      <div class="add-goods-pop__main">
        <!-- saas类型选项 [[ -->
        <section class="radio-wrap">
          <qc-radio v-for="(supportSaasType, index) in currentMediaSupportSaasType" :key="index" v-model="saasType" :value="supportSaasType">
            {{ saasTypeConfig[supportSaasType].name }}
          </qc-radio>
        </section>
        <!-- ]] saas类型选项 -->

        <!-- 链接检测 [[ -->
        <div class="input-wrap">
          <section class="jd-content">
            <el-input
              v-model="productUrl"
              :placeholder="saasTypeConfig[saasType].linkInputPlaceholder || '请输入商品ID或商品短链接'"
              size="small"
            />
            <!-- <el-button :loading="recognitionBtnLoading" class="btn-primary" type="primary" size="small" @click="linkRecognitionHandle">
              识别链接
            </el-button> -->
            <!-- 临时版本 -->
            <el-button :loading="addProductBtnLoading" class="btn-primary" type="primary" size="small" @click="addProductHandle">
              确认添加
            </el-button>
          </section>

          <p v-if="currentMedia === 'qq_xsj'" class="input-tips">注意：食品酒水类商品为QQ小世界禁售商品</p>

          <!-- 链接识别状态 [[ -->
          <div class="link-recognition">
            <div v-show="linkRecognitionState.showLoading" class="link-recognition__loading">
              <i class="link-recognition__ico el-icon-loading" />&nbsp;{{ linkRecognitionState.msg || "商品识别中，请耐心等待" }}
            </div>

            <div v-show="linkRecognitionState.showError" class="link-recognition__error">
              <i class="link-recognition__ico el-icon-error" />&nbsp;{{ linkRecognitionState.msg || "商品识别失败，请检查商品链接是否正确" }}
            </div>

            <!-- 链接详情 [[ -->
            <div v-show="linkRecognitionState.showData" class="link-detail">
              <el-image
                class="link-detail__img"
                style="width: 100px; height: 100px"
                :src="linkRecognitionData.imgUrl"
                fit="cover"
              />
              <div class="link-detail__main">
                <h3 class="link-detail__title">
                  {{ linkRecognitionData.goodsTitle }}
                </h3>
                <p class="link-detail__price">
                  {{ linkRecognitionData.goodsPrice }}
                </p>
              </div>
            </div>
            <!-- ]] 链接详情 -->
          </div>
          <!-- ]] 链接识别状态 -->

          <div v-show="linkRecognitionState.showData" class="bottom-button">
            <el-button class="btn-default" size="small" @click="onClose">
              取消
            </el-button>
            <el-button :loading="addProductBtnLoading" class="btn-primary" type="primary" size="small" @click="addProductHandle">
              确认添加
            </el-button>
          </div>
        </div>
        <!-- ]] 链接检测 -->
      </div>
    </Popup>
  </div>
</template>

<script>
import request from '@/lib/request';
import Popup from '@/components/popup';
import { mapState, mapGetters } from 'vuex';
import commonMixin from '@/mixins/common';
import amount from '@/utils/amount';

export default {
  name: 'AddGoodsPop',
  components: {
    Popup,
  },
  mixins: [commonMixin],
  data() {
    return {
      isShowBind: true,
      saasType: 'jd',
      productUrl: '', // 用户填写的商品链接
      approvedProductUrl: '',  // 识别链接后可添加的商品链接
      // 各个媒体支持的SaaS类型
      mediaSupportSaasType: {
        kg: ['jd', 'pdd', 'youzan'],
        ws: ['jd', 'jx', 'pdd', 'youzan'],
        om: ['jd', 'pdd', 'youzan'],
        qq: ['jd', 'pdd', 'youzan'],
        txvideo: ['jd', 'pdd', 'youzan'],
        kd_app: ['jd', 'pdd', 'youzan'],
        qq_xsj: ['jd', 'pdd', 'youzan'],
      },
      // SaaS类型表单配置，其中 key 为提交后台接口的 saas_type
      saasTypeConfig: {
        jd: {
          name: '京东',
          linkInputPlaceholder: '请输入京东联盟商品链接或商品短链接',
        },
        pdd: {
          name: '拼多多',
          linkInputPlaceholder: '请输入拼多多商品ID或商品短链接',
        },
        jx: {
          name: '京喜',
          linkInputPlaceholder: '请输入京东联盟商品链接或商品短链接',
        },
        youzan: {
          name: '有赞',
          linkInputPlaceholder: '请输入商品ID或商品短链接',
        },
        wd: {
          name: '微店',
          linkInputPlaceholder: '请输入商品ID或商品短链接',
        },

        ams_jd: {
          name: '京东',
          linkInputPlaceholder: '请输入京东联盟商品链接或商品短链接',
        },
        ams_pdd: {
          name: '拼多多',
          linkInputPlaceholder: '请输入拼多多商品ID或商品短链接',
        },
        ams_jx: {
          name: '京喜',
          linkInputPlaceholder: '请输入京东联盟商品链接或商品短链接',
        },
        ams_youzan: {
          name: '有赞',
          linkInputPlaceholder: '请输入商品ID或商品短链接',
        },
        ams_wd: {
          name: '微店',
          linkInputPlaceholder: '请输入商品ID或商品短链接',
        },
      },
      linkRecognitionState: {
        showLoading: false,
        showError: false,
        showData: false,
        msg: '',
      },
      linkRecognitionData: {
        imgUrl: '',
        goodsTitle: '',
        goodsPrice: '',
      },
      recognitionBtnLoading: false,
      addProductBtnLoading: false,
      // 轮询查询商品详情开关
      enablePollQueryGoodsDetail: false,
      // 链接识别出的商品ID，用于查询和添加商品
      queryProductID: '',
    };
  },
  computed: {
    ...mapState({
      mediaId: state => state.manage.filter.mediaId,
      profile: state => state.userCenter.profile,
      addGoodsPop: state => state.common.addGoodsPop,
    }),
    ...mapGetters({
      isBindJd: 'userCenter/isBindJd',
      isBindPdd: 'userCenter/isBindPdd',
    }),
    // 当前媒体支持的 saasType
    currentMediaSupportSaasType() {
      return this.mediaSupportSaasType[this.$route.params.media];
    },
    // 当前媒体，例：qq_xsj、qq、om
    currentMedia() {
      return this.$route.params.media;
    },
  },
  watch: {
    'addGoodsPop.isShow'(newVal) {
      if (newVal === true) {
        const [defaultSaasType] = this.currentMediaSupportSaasType;
        this.saasType = defaultSaasType;
      }
    },
    saasType() {
      this.resetFormData();
    },
  },
  methods: {
    onClose() {
      this.$store.commit('common/HIDE_ADD_GOODS_POP');

      this.resetFormData();
    },

    // 添加商品链接
    addProductHandle() {
      if (!this.checkForm()) return;

      this.addProductBtnLoading = true;
      const { media } = this.$route.params;
      request({
        url: 'v4/show_window/add_product_to_show_window',
        method: 'post',
        data: {
          saas_type: this.saasType,
          saas_product_id: this.approvedProductUrl || this.productUrl,
          media_id: this.mediaId,
          media_type: media,
          scene: 2, // 添加商品链接
          operator_id: this.profile.user_id.toString(),
          operator: this.profile.nickname || '-',
        },
      })
        .then((res) => {
          const code = res.head && res.head.code;
          if (code !== undefined && code !== 0) {
            if ([5320, 5307, 5321].indexOf(code) !== -1) {
              this.showBindSaasPop(code);
            }
            return;
          }

          const data = res || {};
          if (Number(data.is_new_created) !== 1) {
            this.$tip.error('该商品已加入到橱窗中，请勿重复添加');
            return;
          }

          this.$tip.success('成功添加到我的橱窗');
          // 后台数据非实时同步，为了用户体验，延迟刷新数据
          const timer = setTimeout(() => {
            clearTimeout(timer);
            this.$store.dispatch('manage/fetchProducts');
          }, 1200);
          this.onClose();
        })
        .catch((errData) => {
          if ([5320, 5307, 5321].indexOf(errData.code) !== -1) {
            this.showBindSaasPop(errData.code);
          }
        })
        .finally(() => {
          this.addProductBtnLoading = false;
        });
    },

    // 识别商品链接
    linkRecognitionHandle() {
      if (!this.checkForm()) return;

      this.recognitionBtnLoading = true;
      this.setLinkRecognitionState({
        state: 'showLoading',
      });

      request({
        url: 'v1/chosen_product_sync/ImportProductForIDLink',
        method: 'post',
        data: {
          saas_type_str: this.saasType,
          saas_id_link: this.productUrl,
        },
      })
        .then((res) => {
          // 响应成功，轮询商品详情
          const data = res || {};
          const result = data.result;
          const STATUS_CONFIG = {
            ACCEPTED: 1,
            PRODUCT_NOT_FOUND: 2,
            REJECTED: 3,
            AUDIT_TIMEOUT: 4,
          };

          // 审核成功和超时的情况，则用户可以继续添加商品。超时的情况是为了兼容老版本的添加商品体验，由后台进行容错监控。如果后期接口稳定，可去除超时的逻辑
          if (Number(result) === STATUS_CONFIG.ACCEPTED || Number(result) === STATUS_CONFIG.AUDIT_TIMEOUT) {
            const productDetail = data.product_info || {};
            this.linkRecognitionData.imgUrl = (productDetail.main_pics && productDetail.main_pics.split(';')[0]) || '';  // 多图以;分隔的字符串
            this.linkRecognitionData.goodsTitle = productDetail.title || '';
            this.linkRecognitionData.goodsPrice = productDetail.price !== undefined && productDetail.price !== '' ? `￥${amount.fen2Yuan(productDetail.price)}` : '';
            this.approvedProductUrl = this.productUrl;

            // 响应成功，处理数据
            this.setLinkRecognitionState({
              state: 'showData',
            });
            return;
          }

          // 商品审核失败或链接提供错误
          const errMsg = '商品识别失败，请检查商品链接是否正确';
          this.setLinkRecognitionState({
            state: 'showError',
            msg: errMsg,
          });
        })
        .catch((errData) => {
          const errMsg = errData.code ? `商品识别失败，错误码：${errData.code}，错误信息：${errData.message}` : '商品识别失败，请检查商品链接是否正确';
          this.setLinkRecognitionState({
            state: 'showError',
            msg: errMsg,
          });
        })
        .finally(() => {
          this.recognitionBtnLoading = false;
        });
    },

    // 检查表单
    checkForm() {
      if (!this.mediaId) {
        this.$tip.error('未拉取到媒体ID');
        return false;
      }

      if (!this.productUrl.trim()) {
        this.$tip.error('链接不能为空');
        return false;
      }

      return true;
    },

    resetFormData() {
      this.productUrl = '';
      this.approvedProductUrl = '';

      this.linkRecognitionData.imgUrl = '';
      this.linkRecognitionData.goodsTitle = '';
      this.linkRecognitionData.goodsPrice = '';

      this.linkRecognitionState.showLoading = false;
      this.linkRecognitionState.showError = false;
      this.linkRecognitionState.showData = false;
      this.linkRecognitionState.msg = '';

      this.enablePollQueryGoodsDetail = false; // 轮询关闭
      this.recognitionBtnLoading = false;
      this.addProductBtnLoading = false;
    },

    /*
      参数 state, String, UI状态，枚举值为 "showLoading" || "showError" || "showData"
      参数 msg, String, loading提示消息或接口报错消息
     */
    setLinkRecognitionState({
      state,
      msg = '',
    }) {
      this.linkRecognitionState.showLoading = false;
      this.linkRecognitionState.showError = false;
      this.linkRecognitionState.showData = false;
      this.linkRecognitionState.msg = msg;

      if (state === 'showLoading') {
        this.linkRecognitionState.showLoading = true;
      }

      if (state === 'showError') {
        this.linkRecognitionState.showError = true;
      }

      if (state === 'showData') {
        this.linkRecognitionState.showData = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.add-goods-pop {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: rgba(33, 33, 33, 0.6);
  .radio-wrap {
    margin-top: 20px;
  }
  .tip-wrap {
    display: flex;
    align-items: center;
    margin-top: 15px;
    color: #707070;
    font-size: 12px;
    .icon-tip {
      width: 16px;
      margin-right: 4px;
    }
  }

  .label {
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .panel {
    margin-top: 80px;
    text-align: center;
  }
  .item {
    position: relative;
    display: inline-block;
    .input-wrap {
      position: relative;
      padding: 10px;
      top: 66px;
      box-sizing: border-box;
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      width: 460px;
      box-shadow: 0 0 4px 0px rgba(113, 109, 109, 0.334);
      & > div {
        padding: 10px;
      }
    }
  }
}
</style>

<style lang="less">
.add-goods-pop {
  .btn-primary, .btn-default {
    min-width: 80px;
  }

  .header {
    font-size: 16px;
  }
  .tc-15-input-text.m {
    width: 300px;
    border-color: #9b9b9b;
  }
  .tc-15-input-text.xl {
    width: 100%;
    border-radius: 4px;
  }
  .tc-15-btn.m {
    margin: 0 10px;
    height: 40px;
    border-radius: 4px;
    &.btn-add-jd {
      border-color: 1px solid #fff;
      background-color: #fff;
      color: var(--ui-main-color);
    }
  }
  .input-wrap {
    & > * {
      font-size: 15px;
    }
    .tc-15-btn.m {
      height: 30px;
      border-color: 1px solid #fff;
      background-color: #fff;
      color: var(--ui-main-color);
      border-radius: 4px;
    }
    .jd-content {
      margin-top: 20px;
      display: flex;
      align-items: center;
      .desc {
        flex: 1;
        margin-right: 20px;
      }

      .btn-primary {
        margin-left: 10px;
        flex: 1 0 auto;
      }
    }
    .error-tip {
      color: #e1251b;
      margin-top: 15px;
      text-align: left;
      font-size: 13px;
    }
  }

  .input-tips {
    padding-top: 10px;
    font-size: 12px;
    color: #f00;
  }

  .add-goods-pop__main {
    min-height: 320px;
  }
  // 识别链接后的详情信息
  .link-recognition__error {
    font-size: 12px;
    padding: 10px 0;
    color: #F56C6C;
    word-break: break-word;
  }
  .link-recognition__loading {
    font-size: 12px;
    padding: 10px 0;
    color: var(--ui-main-color);
  }
  .link-recognition__ico {
    font-size: 16px;
    vertical-align: -1px;
  }
  .link-detail {
    padding: 20px 0;
    display: flex;

    .link-detail__img {
      flex: 0 0 100px;
      margin-right: 10px;
    }
    .link-detail__main {
      flex: 0 1 auto;
    }
    .link-detail__title {
      font-size: 14px;
      font-weight: 400;
    }
    .link-detail__price {
      padding-top: 10px;
      color: #e02020;
    }
  }

  .bottom-button {
    margin-top: 30px;
    text-align: center;
  }
}

.popup-1 {
  max-width: inherit !important;
  width: 480px !important;
  .jd-content {
    display: flex;
    align-items: center;
    .desc {
      flex: 1;
    }
  }
  .error-tip {
    color: #e1251b;
    margin-top: 6px;
    text-align: left;
  }
  .tc-15-btn.m {
    border-color: 1px solid #fff;
    background-color: #fff;
    color: var(--ui-main-color);
    border-radius: 4px;
  }
}

.tc-15-input-text-wrap.m .tc-15-input-text,
.tc-15-input-text.m {
  flex: 1;
  margin-right: 10px;
}
</style>
